// extracted by mini-css-extract-plugin
export var btn = "Seats-module--btn--05cb5";
export var btnOutlinePrimary = "Seats-module--btn-outline-primary--66f0f";
export var btnPrimary = "Seats-module--btn-primary--27895";
export var card = "Seats-module--card--e5691";
export var content = "Seats-module--content--abff0";
export var formSelect = "Seats-module--form-select--3b04a";
export var inner = "Seats-module--inner--376ca";
export var media = "Seats-module--media--f1784";
export var section = "Seats-module--section--b2391";
export var text = "Seats-module--text--cdd3f";
export var title = "Seats-module--title--dfa6c";